var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBatchImaheActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.25V8H16V2.25C16 2.1125 15.8875 2 15.75 2H8.25C8.1125 2 8 2.1125 8 2.25V19.75C8 19.8875 8.1125 20 8.25 20H16V30H26V6.25C26 6.1125 25.8875 6 25.75 6H18.25C18.1125 6 18 6.1125 18 6.25Z",
    fill: "#006EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 28V22.25C6 22.1125 6.1125 22 6.25 22H17.75C17.8875 22 18 22.1125 18 22.25V28H6Z",
    fill: "#A3D7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 18H12.25C12.1125 18 12 17.8875 12 17.75V16.25C12 16.1125 12.1125 16 12.25 16H21.75C21.8875 16 22 16.1125 22 16.25V17.75C22 17.8875 21.8875 18 21.75 18Z",
    fill: "#A3D7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 26H10.25C10.1125 26 10 25.8875 10 25.75V24.25C10 24.1125 10.1125 24 10.25 24H15.75C15.8875 24 16 24.1125 16 24.25V25.75C16 25.8875 15.8875 26 15.75 26Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 13.75H12.25C12.1125 13.75 12 13.6375 12 13.5V12C12 11.8625 12.1125 11.75 12.25 11.75H21.75C21.8875 11.75 22 11.8625 22 12V13.5C22 13.6375 21.8875 13.75 21.75 13.75Z",
    fill: "#A3D7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 28H3.5V30H28.5V28Z",
    fill: "#006EFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchImaheActive);
export default __webpack_public_path__ + "static/media/batchImahe_active.dc47afb3f518c3de2b28f166b370a408.svg";
export { ForwardRef as ReactComponent };